import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDakisolatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m20 7.32 11.1 8.45v16.91H8.9V15.77z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M19.586 10.807c.245-.245.354-.367.354-.647h1c0 .708-.378 1.085-.633 1.34l-.013.014c-.245.244-.354.366-.354.646s.109.402.354.646l.013.014c.255.255.633.632.633 1.34s-.378 1.085-.633 1.34l-.013.014c-.245.244-.354.366-.354.646s.109.402.354.646l.013.014c.255.255.633.632.633 1.34s-.378 1.085-.633 1.34l-.013.014c-.245.244-.354.366-.354.646h-1c0-.708.378-1.085.633-1.34l.013-.014c.245-.244.354-.366.354-.646s-.109-.402-.354-.646l-.013-.014c-.255-.255-.633-.632-.633-1.34s.378-1.085.633-1.34l.013-.014c.245-.244.354-.366.354-.646s-.109-.402-.354-.646q-.006-.008-.013-.013c-.255-.256-.633-.633-.633-1.341s.378-1.085.633-1.34z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M16 22.68a.3.3 0 0 1 .53.18 2.61 2.61 0 0 0 1.24 2s-1.51-5 2.18-7.44a.23.23 0 0 1 .35.26 2.64 2.64 0 0 0 .81 2.73c1.66 1.65 3.86 2.76 3.9 5.49a4.94 4.94 0 0 1-4.14 5A5 5 0 0 1 15 26a6.6 6.6 0 0 1 1-3.32m3.08 4.85a3.6 3.6 0 0 1-1.25.63.34.34 0 0 0-.1.59 3.64 3.64 0 1 0 4-6.07A3.64 3.64 0 0 1 20 27.81a2.42 2.42 0 0 0 .44-2.45 3.65 3.65 0 0 1-1.36 2.17"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M15.646 15.946c.245-.244.354-.366.354-.646h1c0 .708-.378 1.085-.633 1.34l-.013.014c-.245.244-.354.366-.354.646s.109.402.354.646l.013.013c.255.256.633.633.633 1.341s-.378 1.085-.633 1.34l-.013.014c-.245.244-.354.366-.354.646h-1c0-.708.378-1.085.633-1.34l.013-.014c.245-.244.354-.366.354-.646s-.109-.402-.354-.646l-.013-.014c-.255-.255-.633-.632-.633-1.34s.378-1.085.633-1.34zM24.024 14.154c-.245.244-.354.366-.354.646s.109.402.354.646l.013.014c.255.255.633.632.633 1.34s-.378 1.085-.633 1.34l-.013.014c-.245.244-.354.366-.354.646s.109.402.354.646q.006.008.013.013c.255.256.633.633.633 1.341s-.378 1.085-.633 1.34l-.013.014c-.245.244-.354.366-.354.646h-1c0-.708.378-1.085.633-1.34l.014-.014c.244-.244.353-.366.353-.646s-.109-.402-.354-.646l-.013-.014c-.255-.255-.633-.632-.633-1.34s.378-1.085.633-1.34l.014-.014c.244-.244.353-.366.353-.646s-.109-.402-.354-.646l-.013-.014c-.255-.255-.633-.632-.633-1.34s.378-1.085.633-1.34l.014-.014c.244-.244.353-.366.353-.646h1c0 .708-.378 1.085-.633 1.34z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m20 8.83 9.735 7.473-.61.794L20 10.09l-9.125 7.007-.61-.794z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDakisolatie);

export default ForwardRef;
